module.exports = __webpack_public_path__ + "img/P150T_weapon_29.92256be7.png";